import { render, staticRenderFns } from "./select-checkbox.vue?vue&type=template&id=e5de2b42"
import script from "./select-checkbox.vue?vue&type=script&lang=js"
export * from "./select-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports